<template>
  <div class="EmailFindPwd">
      <div class="" v-if="step === 1">
          <!-- 邮箱 -->
          <van-field 
              v-model.trim="email" 
              :name="$t('forgotPwd.email_address')"
              class="field-input"
              clearable
              clear-trigger="always"
              :placeholder="$t('forgotPwd.email_address')" 
              @touchstart="handleForceFocus('emailInput')"
              ref="emailInput"
          >
                <template #left-icon>
                  <i class="fas fa-envelope icon-color f16"></i>
                </template>
          </van-field>
          <van-button class="login-btn" :disabled="!email" round block type="info" @click="next">{{ $t('forgotPwd.next') }}</van-button>
      </div>
      <div v-if="step === 2">
          <div class="tips1" v-html="tips1">
          </div>
          <van-button class="login-btn" round block type="info" @click="finish">{{ $t('forgotPwd.have_retrieved_it') }}</van-button>
          <div class="tips2">
              {{tips2}} <span v-if="countdown <= 0">{{$t('forgotPwd.or')}} <span class="forgotPwd-resend" @click="handlerSend()">{{$t('forgotPwd.resend')}}</span></span>
              <span v-else>{{countdown}}s</span>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    name:'EmailFindPwd',
    props:{
        queryObj:{
            type:Object,
            default: () => ({})
        }
    },
    data() {
        return {
            email:'',
            step:1,
            countdown: 60,
        }
    },
    computed:{
        tips1() {
            return this.$t('forgotPwd.email_has_been_sent').replace('%@email',"<br/>" + this.email)
        },
        tips2() {
            return this.$t('forgotPwd.unable_to_receive_email').replace('%@email',this.email)
        },
    },
    methods: {
        next() {
            this.handlerSend(() => {
                this.step = 2
            })
        },
        finish() {
            this.$router.go(-1);
        },
        handlerSend(success) {
            this.$http
            .post({
                url: "/bss/app/noauth/SendResetPasswordMail",
                data: {
                    userCode: this.email,
                    registerType: 'EMAIL',
                    enterpriseCode: this.queryObj?.enterpriseCode
                },
                auth:false,
            })
            .then((res) => {
                success && success()
                this.startCountdown(res?.data?.expireTime)
            })
            .catch((err) => {
                console.log(err);
                this.$toast(err);
            });

            // 神策-点击发送验证码
            this.$sensors.track('WebGetCodeClick', {
                service_type: '找回密码',
                get_type: '邮箱',
                account: this.email,
            });
        },
        // 启动倒计时
        startCountdown(num) {
            // 1. 避免重复点击
            if (this.isCounting) return;

            // 2. 初始化状态
            this.isCounting = true;
            this.countdown = 60;

            // 4. 启动计时器
            this.timer = setInterval(() => {
                if (this.countdown <= 1) {
                this.stopCountdown()
                return
                }
                this.countdown--
            }, 1000)
        },

        // 停止倒计时
        stopCountdown() {
            clearInterval(this.timer)
            this.isCounting = false
            this.countdown = 0
        },

        // 输入框获取焦点
        handleForceFocus(ref) {
            this.$refs[ref].focus();
        },
    },
    
    // 组件销毁时清理定时器
    beforeDestroy() {
        this.stopCountdown()
    },
}
</script>

<style lang="less" scoped>
.EmailFindPwd {
    font-family: Source Han Sans;
    background-color: #FFFFFF;
    padding: 24px 20px 0;
    .icon-color {
      color: #99a1af;
    }
    .field-input {
        background-color: #fff;
        border: 1px solid #d1d5dc;
        border-radius: 8px;
        margin-bottom: 40px;
        &:focus-within {
            background: rgba(67, 97, 238, 0.05);
            border: 1px solid #4361ee;
        }
    }
    .login-btn {
        background-color: #4361ee;
        border-radius: 6px;
        border:#4361ee;
        margin-top: 10px;
    }
    .forgotPwd-resend {
        color: #4361ee;
    }
    .tips1 {
        margin-bottom: 40px;
        font-size: 13px;
        -webkit-text-size-adjust: none
    }
    .tips2 {
        margin-top: 40px;
        font-size: 13px;
        color: #929292;
        -webkit-text-size-adjust: none
    }
}
html[dir="rtl"] .EmailFindPwd {
    ::v-deep {
        .van-field__control {
            text-align: right;
        }
        .van-field__left-icon {
            margin-right: unset;
            margin-left: 0.111111rem;
        }
    }
}
</style>